import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimJobItem.ChangeStatus.IRequest;
type Response = Api.Core.ClaimJobItem.ChangeStatus.IResponse;
type Headers = Api.Core.ClaimJobItem.ChangeStatus.IHeaders;
const url = '/api/Claims/ClaimJob/ChangeClaimJobItemStatus/:claimJobItemId/:status';
export default async function changeClaimJobItemStatus(
  claimJobItemId: number,
  status: string
): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.put,
    url: createPathFromRoute(url, { claimJobItemId, status }),
    body: {},
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
